import React from 'react'
import CCLALoading from '../../assets/img/loading.gif'
import './AuthLoader.css'

class AuthLoader extends React.Component {
  render () {
    return (
      <div className='AuthLoader'>
          <img src={CCLALoading} height='150px' alt=''
            className='Loader'/>
      </div>
    )
  }
}

export default AuthLoader
